import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { AuditsTab } from '../../Compliance/AuditsTab';
// AuditsTab owns the whole Audits surface now — header, the compliance summary
// band (the former standalone AuditList widget, folded in above the list), the
// audit table, and the footnote — so this page is just the program-scoped shell.
export function AuditsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(AuditsTab, {
            programId: programId
        })
    });
}
